import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../Helpers";
import Pagination from "@mui/material/Pagination";

const MembershipSubscriberDetails = () => {
  const { id, submembershipId, subscriberId, pivot } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");
  const [transactions, setTransactions] = useState(null);

  // <DataTable
  //   columnContentTypes={["text", "text", "text", "text"]}
  //   headings={[
  //     <Text variant="bodyMd" as="p" fontWeight="medium">
  //       Classes
  //     </Text>,
  //     <Text variant="bodyMd" as="p" fontWeight="medium">
  //       Remaining free bookings per month
  //     </Text>,

  //     <Text variant="bodyMd" as="p" fontWeight="medium">
  //       Total bookings count
  //     </Text>,
  //   ]}
  //   rows={
  //     result?.classes_included?.length &&
  //     result?.classes_included.map((item, index) => [
  //       item.class_list?.map((item) => item.name).join(", "),
  //       item?.remaining_free_bookings_per_month !== null
  //         ? item?.remaining_free_bookings_per_month
  //         : "-",
  //       item?.total_bookings_count !== null ? item?.total_bookings_count : "-",
  //     ])
  //   }
  //   verticalAlign="middle"
  //   increasedTableDensity
  //   hasZebraStripingOnData
  // />; const [pageClasses, setPageClasses] = useState(1);
  const [pageClasses, setPageClasses] = useState(1);
  const [classes, setClasses] = useState(null);
  const [totalClasses, setTotalClasses] = useState("");
  const perPage = 10;
  const refBoolPageClasses = useRef(true);

  const handleChangePageClasses = (event, value) => {
    refBoolPageClasses.current = true;
    setPageClasses(value);
  };
  const handleChangePageBookings = (event, value) => {
    refBoolPageBookings.current = true;
    setPageBookings(value);
  };
  const [bookingPivotId, setBookingPivotId] = useState(null);

  useEffect(() => {
    fetchClasses(bookingPivotId);
  }, [pageClasses]);
  async function fetchClasses() {
    let responseClasses = "";
    try {
      responseClasses = await axios.get(
        `/submemberships/${submembershipId}/classes?subscriber_id=${subscriberId}&booking_id=${pivot}&per_page=${perPage}&page=${
          refBoolPageClasses.current ? pageClasses : 1
        }`
      );
      console.log("classes=", responseClasses.data.data.data);
      setClasses(
        responseClasses.data.data.data.map((item, index) => [
          item.class_list?.map((item) => item.name).join(", "),
          item?.remaining_free_bookings_per_month !== null
            ? item?.remaining_free_bookings_per_month
            : "-",
          item?.total_bookings_count !== null
            ? item?.total_bookings_count
            : "-",
        ])
      );
      setTotalClasses(responseClasses.data.data.total);
    } catch (error) {
      console.log(error);
    }
  }
  const [pageBookings, setPageBookings] = useState(1);
  const [bookings, setBookings] = useState(null);
  const [totalBookings, setTotalBookings] = useState("");
  const refBoolPageBookings = useRef(true);

  useEffect(() => {
    fetchBookings(bookingPivotId);
  }, [pageBookings]);
  async function fetchBookings() {
    let responseBookings = "";
    try {
      responseBookings = await axios.get(
        `/submemberships/${submembershipId}/bookings?subscriber_id=${subscriberId}&booking_id=${pivot}&per_page=${perPage}&page=${
          refBoolPageClasses.current ? pageClasses : 1
        }`
      );
      setBookings(
        responseBookings.data.data.data.map((item, index) => [
          item?.class_name ?? "-",
          item?.session_date ? item?.session_date : "-",
          // item?.class_membership_info?.free_bookings_per_month !==
          // null
          //   ? item?.class_membership_info?.free_bookings_per_month
          //   : "-",
          item?.amount !== null ? item?.amount : "-",
          // item?.class_membership_info?.remaining_bookings !== null
          //   ? item?.class_membership_info?.remaining_bookings
          //   : "-",
          // item?.class_membership_info?.is_limited
          //   ? item?.class_membership_info?.is_limited
          //   : "-",
          item?.status ? (
            <Badge tone={switchStatusColorBooking(item.status)}>
              {capitalizeFirstLetter(item.status)}
            </Badge>
          ) : (
            "-"
          ),
          item?.created_at
            ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        ])
      );
      setTotalBookings(responseBookings.data.data.total);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";
    let responseTransactions = "";
    try {
      responseItem = await axios.get(
        `/memberships/${id}/submemberships/${submembershipId}/subscribers/${subscriberId}/booking/${pivot}`
      );
      setResult(responseItem.data.data);
      // setBookingPivotId(responseItem.data.data?.pivot?.id ?? null);
    } catch (error) {
      console.log(error);
    }
    // try {
    //   responseTransactions = await axios.get(`/app/users/${id}/logs`);
    //   responseTransactions.data.data &&
    //     responseTransactions.data.data.lenght &&
    //     setTransactions(
    //       responseTransactions.data.data.map((item, index) => [
    //         item?.event ? item?.event : "-",
    //         item?.description ? item?.description : "-",
    //         item?.created_at
    //           ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
    //           : "-",
    //       ])
    //     );
    // } catch (error) {
    //   console.log(error);
    // }
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Amount has been added successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `critical`;
      default:
        return "";
    }
  };

  const switchStatusColorBooking = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  return result ? (
    <Page
      // narrowWidth
      backAction={{
        onAction: () =>
          navigate(
            `/admin/memberships/${id}/submemberships/${submembershipId}/subscribers`
          ),
      }}
      title={`${result?.first_name ? result?.first_name : ""} ${
        result?.last_name ? result?.last_name : ""
      }`}
      titleMetadata={
        <Badge tone={switchStatusColor(result?.pivot?.status)}>
          {result?.pivot?.status}
        </Badge>
      }
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              SUBSCRIBER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br /> {result?.first_name ? result?.first_name : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br /> {result?.last_name ? result?.last_name : "-"}
              </Text>
              <Text>
                <b>Email</b>
                <br /> {result?.email ? result?.email : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Nationality</b>
                <br /> {result?.nationality ? result?.nationality : "-"}
              </Text>
              <Text breakWord>
                <b>Phone Number</b>
                <br /> {result?.phone_number ? result?.phone_number : "-"}
              </Text>
              <Text breakWord>
                <b>Created at</b>
                <br />
                {result?.pivot?.created_at
                  ? moment(result?.pivot?.created_at).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Is available?</b>
                <br /> {result?.pivot?.is_valid ? "Yes" : "No"}
              </Text>
              <Text breakWord>
                <b>Start Date</b>
                <br />
                {result?.pivot?.start_date ? result?.pivot?.start_date : "-"}
              </Text>
              <Text breakWord>
                <b>Expiry Date</b>
                <br />
                {result?.pivot?.expiry_date ? result?.pivot?.expiry_date : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Bookings Cap</b>
                <br /> {result?.submembership_booking_cap ?? 0}
              </Text>
              <Text breakWord>
                <b>Remaining Bookings</b>
                <br />
                {result?.remaining_bookings ?? 0}
              </Text>
              <Text breakWord>
                <b>Total Bookings</b>
                <br />
                {result?.bookings_count ?? 0}
              </Text>
            </FormLayout.Group>

            {classes?.length ? (
              <FormLayout>
                <Text variant="headingSm" as="h6">
                  CLASSES INCLUDED
                </Text>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Classes
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Remaining free bookings per month
                    </Text>,

                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Total bookings count
                    </Text>,
                  ]}
                  rows={classes}
                  verticalAlign="middle"
                  increasedTableDensity
                  hasZebraStripingOnData
                />
                {Math.ceil(totalClasses / perPage) >= 2 && (
                  <div
                    style={{
                      paddingTop: "10px",
                      textAlign: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <Pagination
                      variant="outlined"
                      count={Math.ceil(totalClasses / perPage)}
                      page={pageClasses}
                      onChange={handleChangePageClasses}
                    />
                    {/* <Pagination
                                          count={Math.ceil(pageObject.tableTotalPages / perPage)}
                                          page={page}
                                          onChange={handleChangePage}
                                          size="large"
                                        /> */}
                  </div>
                )}
              </FormLayout>
            ) : null}
            {bookings?.length ? (
              <FormLayout>
                <Text variant="headingSm" as="h6">
                  BOOKINGS
                </Text>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Class
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Session Date
                    </Text>,
                    // <Text variant="bodyMd" as="p" fontWeight="medium">
                    //   Free bookings per month
                    // </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Booked Price
                    </Text>,
                    // <Text variant="bodyMd" as="p" fontWeight="medium">
                    //   Remaining Bookings
                    // </Text>,
                    // <Text variant="bodyMd" as="p" fontWeight="medium">
                    //   Limited / Unlimited
                    // </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Status
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Created at
                    </Text>,
                  ]}
                  rows={bookings}
                  verticalAlign="middle"
                  increasedTableDensity
                  // truncate
                  // footerContent={
                  //   pageObject.tableItems?.length &&
                  //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                  // }
                  hasZebraStripingOnData
                />
                {Math.ceil(totalBookings / perPage) >= 2 && (
                  <div
                    style={{
                      paddingTop: "10px",
                      textAlign: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <Pagination
                      variant="outlined"
                      count={Math.ceil(totalBookings / perPage)}
                      page={pageBookings}
                      onChange={handleChangePageBookings}
                    />
                    {/* <Pagination
                                          count={Math.ceil(pageObject.tableTotalPages / perPage)}
                                          page={page}
                                          onChange={handleChangePage}
                                          size="large"
                                        /> */}
                  </div>
                )}
              </FormLayout>
            ) : null}
          </FormLayout>
        </Card>
        {/* <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              TRANSACTIONS
            </Text>

            {transactions?.length ? (
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Event
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Description
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Created at
                  </Text>,
                ]}
                rows={transactions}
                verticalAlign="middle"
                increasedTableDensity
                // truncate
                // footerContent={
                //   pageObject.tableItems?.length &&
                //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                // }
                hasZebraStripingOnData
              />
            ) : transactions !== null ? (
              <Text>No transactions found for this user</Text>
            ) : null}
          </FormLayout>
        </Card> */}
      </FormLayout>
      {/* <PageActions
        secondaryActions={
          <Button
            variant="primary"
            loading={isSaving}
            tone="critical"
            onClick={() => {
              setIsSaving(true);
              axios
                .delete(`/app/users/${id}`)
                .then((result) => {
                  navigate("/admin/users");
                })
                .catch((err) => console.log(err));
            }}
          >
            Delete
          </Button>
        }
      /> */}
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default MembershipSubscriberDetails;
